import declare from "dojo/_base/declare";
import BaseRenderer from "./BaseRendererForDateTime";
import { getDefaultDateTimeFormat, convertCentricToStandardLocale, FORMAT_DATE } from "csi/utility/dateUtility";
import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";

const DatePatternRenderer = declare(BaseRenderer, {

	dateTimeSelector: "date",
	invalidDateTimeResource: "InvalidDateFormatException",

	/**
	 * @override
	 * If entered value is empty then return the default date pattern for the current locale
	 */
	fromHtmlDynamic(ctx: Context, h: Heading, editNode: HTMLElement): string {
		const value = this.inherited<string>(arguments);
		if (!value) {
			return getDefaultDateTimeFormat(convertCentricToStandardLocale(ctx.getParent().$Name), FORMAT_DATE);
		}
		return value;
	},
});

export = DatePatternRenderer;
